import { hasAnyPermissions } from 'src/utils/permissions';
import { Navigate } from 'react-router-dom';
import { User } from 'src/types/user';
import { profileRoutes } from 'src/components/dashboard/profile/routes';

export const getDefaultRoute = (routes, permissions: string[], user: User) => {
  if (!user) {
    return {
      path: '/',
      element: <Navigate to="/" />,
      defaultPathIf: null,
    };
  }

  const invalidDefaults = ['profile', 'library', ''];

  const path =
    routes.children.find(child =>
      hasAnyPermissions(permissions, child.defaultPathIf),
    )?.path || '';

  const defaultPath = invalidDefaults.includes(path)
    ? profileRoutes.profile(user.id)
    : path;

  return {
    path: '/',
    element: <Navigate to={defaultPath} />,
    defaultPathIf: null,
  };
};
